import {
  REQUEST_STATE_INJECTION,
  RESET_INJECTION_STATE,
  STATE_INJECTED,
  type Actions,
} from './actions';
import { initialState, type StateInjection } from './model';

export function stateInjectionReducer(
  state: StateInjection = initialState,
  action: Actions,
): StateInjection {
  switch (action.type) {
    case REQUEST_STATE_INJECTION:
      return {
        ...state,
        stateByPage: {
          ...state.stateByPage,
          [action.pageName]: 'requested',
        },
      };

    case STATE_INJECTED:
      return {
        ...state,
        stateByPage: {
          ...state.stateByPage,
          [action.pageName]: 'ready',
        },
      };

    case RESET_INJECTION_STATE:
      return {
        ...state,
        stateByPage: {
          ...state.stateByPage,
          [action.pageName]: 'idle',
        },
      };

    default:
      return state;
  }
}
